function useRefSection() {
  const refScroll = (
    ctaLinkRef: any,
    headerRef: any,
    isSmallScreen: boolean,
    isMediumScreen: boolean,
    bottomSheet?: boolean
  ) => {
    // const headerHeight = headerRef?.current?.clientHeight;
    let offset = isSmallScreen ? 45 : isMediumScreen ? 45 : -30;
    if (bottomSheet) ctaLinkRef.scrollIntoView({ behavior: 'auto', block: 'nearest' });
    else {
      window.scrollTo({
        top: ctaLinkRef?.offsetTop + offset,
        left: 0,
        behavior: 'smooth',
      });
    }
  };
  return {
    refScroll,
  };
}

export { useRefSection };
